$(document).ready(function(){
  // $("#Details-HeaderSubMenu-1").click(function(){
  //   $("#Details-HeaderSubMenu-2").removeAttr("open");
  // });



  
  // $( ".sub_details" ).toggle( "slow", function() {
  //   $(".sub_details").removeAttr("open");
  //   $(this).attr("open");
  // });


  // $( "#sub_details" ).toggle(function() {
  //   $(".sub_details").removeAttr("open");
  // }, function() {
  //   $(this).removeAttr("open");
  // });

  
  // $(".sub_details").toggle(function(){
  //   $(".sub_details").removeAttr("open");
  // });
});

document.querySelectorAll('.accordion details').forEach(detail => {
  detail.addEventListener('click', function () {
    document.querySelectorAll('.accordion details[open]').forEach(openDetail => {
      if (openDetail !== detail) {
        openDetail.removeAttribute('open');
      }
    });
  });
});
document.querySelectorAll('.header__submenu  details').forEach(detail => {
  detail.addEventListener('click', function () {
    document.querySelectorAll('.header__submenu  details[open]').forEach(openDetail => {
      if (openDetail !== detail) {
        openDetail.removeAttribute('open');
      }
    });
  });
});